import { useState } from "react";
import SEO from "../components/common/SEO";
import PageHero from "../components/common/PageHero";
import { StaggerGroup } from "../components/common/Reveal";
import BlogCard from "../components/cards/BlogCard";
import CTASection from "../components/common/CTASection";
import { insights, insightCategories } from "../data/insights";

export default function Insights() {
  const [active, setActive] = useState("All");
  const filtered = active === "All" ? insights : insights.filter((i) => i.category === active);

  return (
    <>
      <SEO
        title="Insights"
        description="Perspectives on AI, data, cloud, engineering and technology staffing from AMVI Technologies."
        path="/insights"
      />
      <PageHero
        eyebrow="Insights"
        title="Ideas on Technology & Talent"
        subtitle="Perspectives on AI, data, cloud, engineering and building high-performing teams."
      />

      <section className="px-6 pb-8">
        <div className="mx-auto max-w-7xl">
          <div className="flex flex-wrap gap-2" data-testid="insights-filters">
            {insightCategories.map((c) => (
              <button
                key={c}
                onClick={() => setActive(c)}
                className={`rounded-full border px-4 py-2 text-sm font-medium transition-colors ${
                  active === c
                    ? "border-sky-400 bg-sky-400 text-ink-900"
                    : "border-white/10 bg-white/5 text-slate-300 hover:border-white/30 hover:text-white"
                }`}
                data-testid={`insights-filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {c}
              </button>
            ))}
          </div>

          <StaggerGroup className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" stagger={0.06}>
            {filtered.map((post) => (
              <BlogCard key={post.slug} post={post} />
            ))}
          </StaggerGroup>
        </div>
      </section>

      <CTASection />
    </>
  );
}
